// Centralized list of GA event names (gtag `event` action) used across the app.
// Add a new entry here whenever a new gtag event is introduced.
export default {
  Claim: 'claim',
  Click: 'Click',
  View: 'View',
};
